
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      // Close mobile menu if open
      if (mobileMenuOpen) setMobileMenuOpen(false);
      
      // Smooth scroll to the target section with proper offset for fixed header
      const headerOffset = isMobile ? 90 : 120; // Increased offset for bigger header
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Update URL without causing page jump
      window.history.pushState(null, '', targetId);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 w-full z-50 bg-white shadow-md py-3 min-h-[90px] md:min-h-[110px]">
      <div className="container flex justify-between items-center">
        {/* Left-aligned Logo */}
        <a href="/" className="flex items-center overflow-visible">
          <img 
            src="/lovable-uploads/d6ed7d5c-1141-4ed5-8929-7eaf820da085.png" 
            alt="KTjones Management Consulting Logo" 
            className="h-28 md:h-32" // Keeping logo size the same
          />
        </a>

        {/* Desktop Navigation - Right aligned */}
        <nav className="hidden md:flex items-center space-x-8">
          <a 
            href="#services" 
            onClick={(e) => handleSmoothScroll(e, '#services')}
            className="text-charcoal hover:text-maroon transition-colors"
          >
            Services
          </a>
          <a 
            href="#about" 
            onClick={(e) => handleSmoothScroll(e, '#about')}
            className="text-charcoal hover:text-maroon transition-colors"
          >
            About
          </a>
          <a 
            href="#testimonials"
            onClick={(e) => handleSmoothScroll(e, '#testimonials')} 
            className="text-charcoal hover:text-maroon transition-colors"
          >
            Testimonials
          </a>
          <a 
            href="#contact"
            onClick={(e) => handleSmoothScroll(e, '#contact')} 
            className="text-charcoal hover:text-maroon transition-colors"
          >
            Contact
          </a>
        </nav>

        {/* Mobile Menu Button - Right aligned */}
        <button 
          className="md:hidden p-2 text-charcoal"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        {/* Mobile Menu with animation */}
        {mobileMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg md:hidden animate-fade-in">
            <div className="flex flex-col p-5 space-y-5">
              <a 
                href="#services" 
                onClick={(e) => handleSmoothScroll(e, '#services')}
                className="text-charcoal hover:text-maroon transition-colors text-lg py-2"
              >
                Services
              </a>
              <a 
                href="#about" 
                onClick={(e) => handleSmoothScroll(e, '#about')}
                className="text-charcoal hover:text-maroon transition-colors text-lg py-2"
              >
                About
              </a>
              <a 
                href="#testimonials" 
                onClick={(e) => handleSmoothScroll(e, '#testimonials')}
                className="text-charcoal hover:text-maroon transition-colors text-lg py-2"
              >
                Testimonials
              </a>
              <a 
                href="#contact" 
                onClick={(e) => handleSmoothScroll(e, '#contact')}
                className="text-charcoal hover:text-maroon transition-colors text-lg py-2"
              >
                Contact
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
